var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDevice(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "19px",
    viewBox: "0 0 13 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-00-MyClients-editAction",
    transform: "translate(-221.000000, -679.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-deviceInfo",
    transform: "translate(222.000000, 680.000000)",
    stroke: "#646464",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2,17 L1.13333333,17 C0.507166667,17 0,16.4928333 0,15.8666667 L0,1.13333333 C0,0.507166667 0.507166667,0 1.13333333,0 L10.2,0 C10.8261667,0 11.3333333,0.507166667 11.3333333,1.13333333 L11.3333333,15.8666667 C11.3333333,16.4928333 10.8261667,17 10.2,17 L10.2,17 Z",
    id: "Stroke-4829",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-4830",
    strokeWidth: 0.8,
    points: "9.06666667 12.4666667 2.26666667 12.4666667 2.26666667 2.83333333 9.06666667 2.83333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1,14.7333333 C5.1,14.4205333 5.35386667,14.1666667 5.66666667,14.1666667 C5.97946667,14.1666667 6.23333333,14.4205333 6.23333333,14.7333333 C6.23333333,15.0461333 5.97946667,15.3 5.66666667,15.3 C5.35386667,15.3 5.1,15.0461333 5.1,14.7333333 L5.1,14.7333333 Z",
    id: "Stroke-4831",
    strokeWidth: 0.8
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDevice);
export default __webpack_public_path__ + "static/media/icDevice.cc687c49d6c194f5f47a83fe1a85ead6.svg";
export { ForwardRef as ReactComponent };